import { jsonConstants } from '@thoughtspot/json-constants';
import { getGuidsToSkip } from '@thoughtspot/session-service';
import React, { createContext, useContext, useMemo, useReducer } from 'react';
import { ANSWER, PINBOARD, SQL_VIEW, TABLE, VIEW, WORKSHEET, } from '../orgs.util';
export const ALL = 'ALL';
export const DEFAULT_PAGINATION_BATCHSIZE = 20;
export const DEFAULT_CATEGORY = 'ALL';
export const DEFAULT_MY = 'MY';
export const DEFAULT_SORT_LAST_ACCESSED = 'LAST_ACCESSED';
export const DEFAULT_SORT_MODIFIED = 'MODIFIED';
export const DEFAULT_SORT_AUTHOR = 'AUTHOR';
export const initialObjectContextInfo = {
    batchSize: DEFAULT_PAGINATION_BATCHSIZE,
    category: DEFAULT_CATEGORY,
    offset: 1,
    searchTerm: '',
    showHidden: false,
    skipIds: getGuidsToSkip(),
    sort: DEFAULT_SORT_MODIFIED,
    sortAscending: false,
    loading: true,
    itemCount: DEFAULT_PAGINATION_BATCHSIZE,
    selectedTag: undefined,
    type: '',
    authorId: '',
    reload: false,
};
export const getConventionalSubTypeMappings = (type) => {
    switch (type.toUpperCase()) {
        case WORKSHEET:
            return jsonConstants.metadataType.subType.WORKSHEET;
        case VIEW:
            return [
                jsonConstants.metadataType.subType.VIEW,
                jsonConstants.metadataType.subType.SQL_VIEW,
            ];
        case TABLE:
            return [
                jsonConstants.metadataType.subType.SYSTEM_TABLE,
                jsonConstants.metadataType.subType.USER_DEFINED,
            ];
        default:
            return undefined;
    }
};
export const getConventionalTypeMappings = (type) => {
    switch (type.toUpperCase()) {
        case WORKSHEET:
        case VIEW:
        case SQL_VIEW:
        case TABLE:
            return jsonConstants.metadataType.LOGICAL_TABLE;
        case ANSWER:
            return jsonConstants.metadataType.QUESTION_ANSWER_BOOK;
        case PINBOARD:
            return jsonConstants.metadataType.PINBOARD_ANSWER_BOOK;
        default:
            return jsonConstants.metadataType.LOGICAL_TABLE;
    }
};
export const getSubtypeParam = (type) => {
    const subtypes = getConventionalSubTypeMappings(type);
    if (!subtypes) {
        return subtypes;
    }
    return Array.isArray(subtypes) ? subtypes : [subtypes];
};
export var ListAction;
(function (ListAction) {
    ListAction[ListAction["SET_LOADING"] = 0] = "SET_LOADING";
    ListAction[ListAction["SET_SORT_COLUMN"] = 1] = "SET_SORT_COLUMN";
    ListAction[ListAction["SET_SORT_ASCENDING"] = 2] = "SET_SORT_ASCENDING";
    ListAction[ListAction["SET_OFFSET"] = 3] = "SET_OFFSET";
    ListAction[ListAction["SET_TYPE"] = 4] = "SET_TYPE";
    ListAction[ListAction["SET_SUB_TYPE"] = 5] = "SET_SUB_TYPE";
    ListAction[ListAction["SET_SELECTED_TAG"] = 6] = "SET_SELECTED_TAG";
    ListAction[ListAction["SET_SEARCH_TERM"] = 7] = "SET_SEARCH_TERM";
    ListAction[ListAction["SET_AUTHOR"] = 8] = "SET_AUTHOR";
    ListAction[ListAction["RELOAD_LIST"] = 9] = "RELOAD_LIST";
    ListAction[ListAction["SET_ORG"] = 10] = "SET_ORG";
})(ListAction || (ListAction = {}));
export const contentListReducer = (state = initialObjectContextInfo, action) => {
    switch (action.type) {
        case ListAction.SET_LOADING:
            return {
                ...state,
                loading: action.payload,
            };
        case ListAction.SET_SORT_COLUMN:
            return {
                ...state,
                sort: action.payload.toUpperCase(),
            };
        case ListAction.SET_SORT_ASCENDING:
            return {
                ...state,
                sortAscending: action.payload,
            };
        case ListAction.SET_OFFSET:
            return {
                ...state,
                offset: action.payload,
            };
        case ListAction.SET_TYPE:
            return {
                ...state,
                type: action.payload,
            };
        case ListAction.SET_SELECTED_TAG:
            return {
                ...state,
                selectedTag: action.payload,
            };
        case ListAction.SET_SEARCH_TERM:
            return {
                ...state,
                searchTerm: action.payload,
            };
        case ListAction.SET_AUTHOR:
            return {
                ...state,
                authorId: action.payload,
            };
        case ListAction.RELOAD_LIST:
            return {
                ...initialObjectContextInfo,
                reload: action.payload,
            };
        case ListAction.SET_ORG:
            return {
                ...state,
                selectedOrg: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};
export const ContentContext = createContext(null);
export const useContentContext = () => useContext(ContentContext);
export const ContentContextProvider = ({ children, }) => {
    const [state, dispatch] = useReducer(contentListReducer, {
        ...initialObjectContextInfo,
    });
    const contextValue = useMemo(() => {
        return { state, dispatch };
    }, [state, dispatch]);
    return (React.createElement(ContentContext.Provider, { value: contextValue }, children));
};
export const getTestContentListReducer = () => contentListReducer;
//# sourceMappingURL=content.js.map